import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export const Protected = ({ children, adminOnly = false }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream text-ink-soft">
        <span className="overline">Loading…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/staff/login" state={{ from: loc }} replace />;
  if (adminOnly && user.role !== "admin")
    return <Navigate to="/staff/dashboard" replace />;
  return children;
};
